import { getToken } from "./token";

export const authorize = () => ({
  headers: {
    Authorization: `Bearer ${getToken()}`, // Set the Authorization header
  },
});

export const authorizeMultipart = () => ({
  headers: {
    "Content-Type": "multipart/form-data",
    Authorization: `Bearer ${getToken()}`,
  },
});

export const authorizeFormData = authorizeMultipart;